<template>
  <!-- 原始数据查询 -->
  <div class="page">
    <div class="paginations" :style="{ filter: this.$store.state.isVague ? 'blur(2px)' : '' }">
      <div class="table-search-box table-search-box-hander">
        <el-form :inline="true" :model="searchData" class="demo-form-inline">
          <el-form-item label="上传id：">
            <el-input size="small" v-model="searchData.monitorId" placeholder="请输入上传id" />
          </el-form-item>
          <el-form-item label="数据类型：">
            <el-select size="small" v-model="searchData.dataType" clearable filterable>
              <el-option
                v-for="item in dataTypeList"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上传时间：">
            <el-input size="small" v-model="searchData.time" placeholder="请输入上传时间" />
          </el-form-item>
          <el-form-item>
            <div class="search_button">
              <i class="pointer el-icon-search" @click="search"></i>
              <i class="pointer el-icon-refresh-left" @click="reset"></i>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <json-view :data="jsonData" theme="vs-code" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 查询条件
      searchData: {
        dataType: "", //数据类型,
        monitorId: "", //上传id
        time: "", //上传时间
        level: this.$store.state.statusRadio, //级别
        zykId: sessionStorage.getItem("zykId"), //资源库id
      },
      //数据类型
      dataTypeList: [
        {
          value: 2,
          name: "用户数据",
        },
        {
          value: 3,
          name: "课程数据",
        },
        {
          value: 4,
          name: "题库数据",
        },
        {
          value: 5,
          name: "资源数据",
        },
        {
          value: 6,
          name: "课程内容和活动实施信息",
        },
        {
          value: 7,
          name: "日志数据",
        },
        {
          value: 8,
          name: "试题数据",
        },
        {
          value: 9,
          name: "作业、测试和考试信息",
        },
        {
          value: 10,
          name: "作业、测试和考试引用试题关系表",
        },

        {
          value: 11,
          name: "论坛信息",
        },
        {
          value: 12,
          name: "开课",
        },
        {
          value: 13,
          name: "选课",
        },
        {
          value: 14,
          name: "课程公告",
        },
        {
          value: 15,
          name: "课程内容和活动部署信息",
        },
        {
          value: 16,
          name: "论坛帖子和回复信息",
        },
        {
          value: 17,
          name: "作业、测试和考试测评打分",
        },
        {
          value: 18,
          name: "课程学习成绩信息",
        },
      ],
      // 可使用 JSON.parse() 对json数据转化
      jsonData: {},
    };
  },
  methods: {
    // 查询
    search() {
      if (this.searchData.monitorId)
        this.$axios
          .post(this.$apiurls.getOriginalDataInfo, this.searchData, { loading: false })
          .then((res) => {
            if (res.code === 200) {
              this.jsonData = res.data;
            }
          });
      else
        this.$message({
          message: "请输入上传id！",
          type: "warning",
        });
    },
    // 重置
    reset() {
      this.searchData = {
        dataType: "", //数据类型,
        monitorId: "", //上传id
        time: "", //上传时间
        level: this.$store.state.statusRadio, //级别
        zykId: sessionStorage.getItem("zykId"), //资源库id
      };
      this.search();
    },
  },
};
</script>

<style lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style lang="scss" src="@/assets/css/tableList.scss" scoped></style>
<style lang="scss" scoped>
.paginations {
  height: 100%;
}
.el-form {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
}
</style>
<style lang="scss">
.el-select-dropdown {
  position: absolute;
  z-index: 1001;
  border: none !important;
  max-height: 268px;
  border-radius: 4px;
  background-color: rgba(26, 38, 72);
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  box-sizing: border-box;
  margin: 5px 0;
  .el-select-dropdown__list {
    box-sizing: border-box;
    padding: -1px 0;
    background: rgba(26, 38, 72) !important;
    .el-select-dropdown__item {
      color: #fff !important;
    }
    .hover,
    .el-select-dropdown__item:hover {
      background: transparent;
      border: 1px solid rgba(27, 246, 248);
    }
    .el-select-dropdown__item:hover span {
      font-size: 14px;
      transform: scale(1);
    }
    .selected {
      color: rgba(27, 246, 248);
    }
  }
  .popper__arrow,
  .popper__arrow::after {
    position: absolute;
    display: "";
    width: "";
    height: "";
    border: none;
    border-style: "";
  }
}
.el-input__inner {
  background: rgba(86, 94, 121, 0.59);
  border-color: rgba(86, 94, 121, 0.59);
  color: #fff;
}
.json-view-container.vs-code {
  background-color: rgb(35, 42, 67) !important;
}
</style>
